/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ProgressDetailsForServiceNowCmdbSync extends models.ProgressDetails {
    getFixupPrototypeFunction() { return ProgressDetailsForServiceNowCmdbSync.fixupPrototype; }

    static newInstance(model: Partial<ProgressDetailsForServiceNowCmdbSync>): ProgressDetailsForServiceNowCmdbSync {
        let obj = Object.assign(new ProgressDetailsForServiceNowCmdbSync(), model);
        ProgressDetailsForServiceNowCmdbSync.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ProgressDetailsForServiceNowCmdbSync>): ProgressDetailsForServiceNowCmdbSync {
        if (!model) return null;
        return ProgressDetailsForServiceNowCmdbSync.newInstance(<ProgressDetailsForServiceNowCmdbSync> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ProgressDetailsForServiceNowCmdbSync) {
        if (!obj) return;

        models.ProgressDetailsForServiceNowCmdbSync.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ProgressDetailsForServiceNowCmdbSync): boolean {
        if (models.ProgressDetails.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ProgressDetailsForServiceNowCmdbSync.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.progress) {
            models.ServiceNowCmdbSyncProgress.fixupPrototype(this.progress);
        }
    }

    /**
     * Progress of the ServiceNow Cmdb sync
     */
    progress: models.ServiceNowCmdbSyncProgress;

}
